import { RedirectLayout } from 'layouts/redirect-layout/RedirectLayout'

export function EmailConfirmed() {
  return <RedirectLayout text="Your account is verified" />
}
